import { HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';  
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
var options = {
  transport: signalR.HttpTransportType.ServerSentEvents ,
  logging: signalR.LogLevel.Trace, 
};
const demoulr="https://shukhee-nonprod-signalr-fvbzcqchh4h8fqbc.southeastasia-01.azurewebsites.net/api/chatHub";
const proulr="https://ez-hms-prod-signalr-app-ser.azurewebsites.net/api/chatHub";
const connectionIdName="connectionId";
const credentials="SomeUserName:SomePassword";
 

@Injectable({
  providedIn: 'root'
})
export class EzoChatAppService { 

  tenantId = localStorage.getItem("tenantId");
  branchId = localStorage.getItem("branchId");
  userId =parseInt(localStorage.getItem("userId"));
  phyID= localStorage.getItem("physicianId"); 

  //Pagename List
  appointmentQueuepname="appointment-queue-page";
  doctorQueuepname="doctor-queue-page";
  analaticsDashboard="analytics-dashboard-page";
  // Invoke and Get Function Name
  //page refresh
  setpageAutoRefresh="setPageAutoRefresh";
  getpageAutoRefresh="getPageAutoRefresh";
  // userlist
  setUserList="getOnlineUsers";
  getUserList="getOnlineUsersList";
  //update apt queue
  setUpdateAptQueue="doctorUpdateAppointmentRecordStatus";
  getUpdateAptQueue="getAppointmentStatusUpdate";

  // Observable methos
  //--page refresh
  private pageRefreshBs: BehaviorSubject<any> = new BehaviorSubject(null);
  public pageRefresh$ = this.pageRefreshBs.asObservable();
  //--appointment queue update
  public aptQueueUpdate = new Subject<any>();
  
  public usersList = new Subject<any>();
  public receiveMsg = new Subject<any>();

  hubConnection:signalR.HubConnection;  
  credential='Basic ' + btoa(credentials);

  headerOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': this.credential
    })
  };
  token:any;

  connectionStatus;
  constructor( ) { 
    this.token=JSON.parse(localStorage.getItem("loginresult"))?.response?.body?.token?.access_token;
    // console.log("toekn", this.token)
  }
    ssSubj = new Subject<any>();
    ssObs(): Observable<any> {
        return this.ssSubj.asObservable();
    }

    startConnection(){ 
      try{
        this.hubConnection = new signalR.HubConnectionBuilder().withUrl(demoulr, {
          accessTokenFactory: () => this.token
        })
        // .configureLogging(signalR.LogLevel.None)
        .withAutomaticReconnect([0, 2000, 30000, 60000, null]).build();
        Object.defineProperty(WebSocket, 'OPEN', { value: 1, }); 
        this.hubConnection.start().then(() => {                     
                this.connectionStatus='Connected';
                this.authMe();
            }).catch(err => {                     
                this.connectionStatus='DisConnected';
                this.hubConnection=null;
            }); 
      }catch(exception)
      {
        this.connectionStatus='DisConnected';
        this.hubConnection=null;
      } 
    }
    endConnection(){ 
      try{
        this.hubConnection.off("");
        this.hubConnection.stop();
        this.hubConnection=null;
      }catch(exception)
      {
        this.connectionStatus='DisConnected';
        this.hubConnection=null;
      } 
    }
    async authMe() {
      if(!!this.hubConnection){
          let personInfo = {userName: this.userId, password: "pass", tenantId:this.tenantId, branchId:this.branchId};
          await this.hubConnection.invoke("authMe", personInfo).then(() => {
                this.setConnectionId(this.hubConnection.connectionId);
                this.addSubscribeMethod()
          }).catch(err => {
            this.hubConnection=null;
            this.connectionStatus='DisConnected';
          });
      }else{

      }
    }
    addSubscribeMethod(){      
      this.pageRefresh();
      this.getOnlineUsersList();
      this.getOnlineUsersInv();
      this.receiveMessage();
      this.getAppointmentStatusUpdate();  
    }
    // set and get Page Refresh
    updateAptQueue(docId:string, aptData: string, type:string ){
      try{
        if(!!this.hubConnection){ 
          this.hubConnection.invoke(this.setUpdateAptQueue,docId,aptData,type,this.tenantId,this.branchId).catch(err => console.error(err));
        }else{

        }
      }catch(ex){

      }
    }
    getAppointmentStatusUpdate(){
      try{
        if(!!this.hubConnection){
          this.hubConnection.on(this.getUpdateAptQueue, (docId:string, aptData: string, type:string) => {
              this.aptQueueUpdate.next({
                "docId":docId,
                "aptData":JSON.parse(aptData),
                "type":type
              })
          });
        }
      }catch(ex){

      }
    }


    // set and get Page Refresh
    pageRefreshApiCall(pageName:string[]){
      try{
        if(!!this.hubConnection){
          this.hubConnection.invoke(this.setpageAutoRefresh,pageName,this.tenantId,this.branchId).catch(err => console.error(err));
        }else{

        }
      }catch(ex){
      }
    }
    pageRefresh(){
      try{
        if(!!this.hubConnection){
          this.hubConnection.on(this.getpageAutoRefresh, (pagename: string[]) => {
              this.pageRefreshBs.next(pagename); 
          });
        }
      }catch(ex){
      }
    }
    // Appointment Records Refresh Api Call
    afterAppointmentPageRefresh(){
        this.pageRefreshApiCall([this.appointmentQueuepname, this.analaticsDashboard, this.doctorQueuepname]);
    }

    // Get Online User list
    getOnlineUsersInv(): void {
      try{
        if(!!this.hubConnection){
          this.hubConnection.invoke(this.setUserList).catch(err => console.error(err));
        }else{}
      }catch(ex){
      }
    }
    getOnlineUsersList(): void {
      try{
        if(!!this.hubConnection){
          this.hubConnection.on(this.getUserList, (onlineUsers: any) => {
            this.usersList.next(onlineUsers);
          });
        }else{}
      }catch(ex){
      }        
    }
    

    // Send Message to Client 
    sendMessage(connectionId,message){
      try{
        if(!!this.hubConnection){
          this.hubConnection.invoke("sendMsg",connectionId,JSON.stringify(message)).catch(err => console.error(err));
        }else{}
      }catch(ex){
      
      }
    }
    // Receive 
    receiveMessage(){
      this.hubConnection.on("sendMsgResponse", (conectionid,receiveMessage: any) => {
        this.receiveMsg.next(receiveMessage);
      });
    }

    // Get and Set Connection ID
    getConnectionId():string{
       return localStorage.getItem(connectionIdName);
    }
    setConnectionId(value){
        localStorage.setItem(connectionIdName,value);
    }

}